import angular from 'angular';
import { CommissionPolicyListComponent } from './commission-policy-list.component';
import { EditCommissionPolicyComponent } from './edit-commission-policy.component';
import { CommissionPolicyArchiveService } from './commission-policy-archive.service';
import { EditCommissionPolicyAbstractComponent } from './edit-commission-policy-abstract.component';

export const CommissionPolicyModule = angular
    .module("apex.mainApp.commissionPolicy", [])
    .component("apexCommissionPolicyList", CommissionPolicyListComponent)
    .component("apexEditCommissionPolicy", EditCommissionPolicyComponent)
    .component("apexEditCommissionPolicyAbstract", EditCommissionPolicyAbstractComponent)
    .factory("commissionPolicyArchiveService", CommissionPolicyArchiveService)
    .name;
